import React from 'react'
import 'moment/locale/zh-cn';
import Link from "react-router-dom/es/Link";
import {Path} from "../../../public/path";
import {FetchUtil} from "../../../public/fetch_util";
import { Table, Button, Popconfirm } from "antd";
import Message from "../../../cmpts/ant/Message";
import {
    URL_DISTRI_NOTICECONFIG_DEL,
    URL_MXD_DISTRI_NOTICECONFIG_LIST,
    URL_DISTRI_NOTICECONFIG
} from '../../../public/variables'

/**
 * 订单管理
 */
let fetchUtil = new FetchUtil();

class GroupCodeData extends React.Component {
    constructor(props) {
        super(props);
        this.getRobotList = this.getRobotList.bind(this);
        this.delete = this.delete.bind(this);
        this.state = {
            list: null,
            pagInfo: null,
            visible: true,
            keynote_list: [],
            msg: {},
        }

    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getRobotList(1);
    }

    getRobotList(pageNum) {
        let arr = [];
        arr.push('pageNum=' + pageNum);
        arr.push('pageSize=10');

        let str = arr.join('&');
        fetchUtil.init()
            .setUrl(URL_MXD_DISTRI_NOTICECONFIG_LIST)
            .setMethod("GET")
            .setHeader({
                'Content-Type': 'application/json'
            })
            .setCookieCors()
            .setBodyType('json')
            .setBody()
            .dofetch()
            .then((msg) => {
                if (msg.respCode == 0) {
                    let list = msg.respMsg;
                    this.setState({
                        list: list
                    })

                }
            })
            .catch((msg) => {

            })
    }

    delete(id, index) {
        fetchUtil.init()
            .setUrl(URL_MXD_DISTRI_NOTICECONFIG_DELETE)
            .setMethod("POST")
            .setHeader({
                'Content-Type': 'application/json'
            })
            .setCookieCors()
            .setBodyType('json')
            .setBody({
                id: id
            })
            .dofetch()
            .then((msg) => {
                if (msg.respCode == 0) {
                    this.getRobotList();
                    Message.success('删除成功')
                } else {
                    Message.error('删除失败，请稍后重试')
                }
            })
            .catch((msg) => {

            })
    }

    render() {
        const Colums = [
            {
                dataIndex: 'key',
                title: '配置名称',
                render: (text, record, index) => (
                    <span>{record.name}</span>
                )
            },
            {
                dataIndex: 'key',
                title: '公众号',
                render: (text, record, index) => (
                    <span>{record.subsName}</span>
                )
            },
            {
                dataIndex: 'key',
                title: '创建时间',
                width:'200px',
                render: (text, record, index) => (
                    <span>{new Date(record.createDate).format('yyyy-MM-dd hh:mm:ss')}</span>
                )
            },
            {
                align: 'center',
                dataIndex: 'key',
                title: '操作',
                render: (text, record, index) => (
                    <ul className={'toRecordBtns retailListBtns'}>
                        <li className={'text-primary'}>
                            <Link to={Path.getDistriNotifyEdit() + record.id}>
                                编辑
                            </Link>
                        </li>
                        <Popconfirm title="确认删除？" onConfirm={this.delete.bind(this, record.id, index)}
                                    okText="确定" cancelText="取消">
                            <li className={'text-primary'}>删除</li>
                        </Popconfirm>
                    </ul>
                )
            }
        ];
        return (
            <div className="contentBody">
                <div className={'mxd-panel minHeightNormal tableLayoutFixed'}>
                    <div className={'clearfix'}>
                        <Link to={Path.getDistriNotifyCreate()}>
                            <Button type="primary" style={{'margin-bottom': '15px'}}>
                                <span>创建消息</span>
                            </Button>
                        </Link>
                    </div>
                    <Table dataSource={this.state.list}
                           pagination={{
                               hideOnSinglePage: true,
                               showQuickJumper: true,
                               total: this.state.pagInfo ? this.state.pagInfo.total : 1,
                               current: this.state.pagInfo ? this.state.pagInfo.pageNum : 1,
                               onChange: this.getRobotList,
                           }}
                           columns={Colums}
                    >

                    </Table>
                </div>

            </div>
        )
    }
}


export default GroupCodeData




